import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});
export const fetchVideos = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    const {
      page = 1,
      per_page = 10,
      id_jenis_soal,
      id_jenis_seleksi,
      id_kategori_paket,
      id_tipe_konten,
      search,
      disable_pagination,
      tipe,
    } = filters;

    console.log(tipe, "ini")

    params.append('page', page);
    params.append('per_page', per_page);
    if (id_jenis_soal) params.append('id_jenis_soal', id_jenis_soal);
    if (id_jenis_seleksi) params.append('id_jenis_seleksi', id_jenis_seleksi);
    if (id_kategori_paket) params.append('id_kategori_paket', id_kategori_paket);
    if (id_tipe_konten) params.append('id_tipe_konten', id_tipe_konten);
    if (search) params.append('search', search);
    if (disable_pagination) params.append('disable_pagination', 'true');
    if (tipe) params.append('tipe', tipe);

    const response = await axios.get(`${BASE_URL_BE}/video?${params.toString()}`, {
      headers: getAuthHeaders()
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching videos:", error);
    throw error;
  }
};

export const fetchVideoSubscribe = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    const {
      page = 1,
      per_page = 10,
      id_jenis_soal,
      id_jenis_seleksi,
      id_kategori_paket,
      id_tipe_konten,
      search,
      disable_pagination,
      tipe,
    } = filters;

    params.append('page', page);
    params.append('per_page', per_page);
    if (id_jenis_soal) params.append('id_jenis_soal', id_jenis_soal);
    if (id_jenis_seleksi) params.append('id_jenis_seleksi', id_jenis_seleksi);
    if (id_kategori_paket) params.append('id_kategori_paket', id_kategori_paket);
    if (id_tipe_konten) params.append('id_tipe_konten', id_tipe_konten);
    if (search) params.append('search', search);
    if (disable_pagination) params.append('disable_pagination', 'true');
    if (tipe) params.append('tipe', tipe);

    const response = await axios.get(`${BASE_URL_BE}/video/subscribe?${params.toString()}`, {
      headers: getAuthHeaders()
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching videos:", error);
    throw error;
  }
};

export const createVideo = async (formData) => {
    try {
      const response = await axios.post(`${BASE_URL_BE}/video`, formData, {
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error creating soal:", error);
      throw error;
    }
  };

// Perbaiki fungsi updateSoal dan deleteSoal
export const updateVideo = async (idVideo, formData) => {
    try {
      const response = await axios.put(`${BASE_URL_BE}/video/${idVideo}`, formData, {
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error updating soal:", error);
      throw error;
    }
  };
  
  export const deleteVideo = async (id) => {
    try {
      const response = await axios.delete(`${BASE_URL_BE}/video/${id}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting soal:", error);
      throw error;
    }
  };